<dx-popup
  [width]="450"
  [height]="'auto'"
  [showTitle]="true"
  title="Notifications Datameal Online"
  [(visible)]="displayNotificationsInfos"
  [resizeEnabled]="true"
  [showCloseButton]="false"
>
  <div *dxTemplate="let data of 'content'">
    <p [innerHTML]="this.notificationsInfos"></p>
  </div>

</dx-popup>

@if (key === 'root') {
  <dx-toast id="toast-root" key="root" [width]="600" [displayTime]="timeMessage" [closeOnClick]="false" [(visible)]="isVisible" [type]="type">
    <div style="text-align: center" *dxTemplate="let data of 'content'">
      @if (urlMessage !== null && urlMessage !== undefined) {
        <a style="text-decoration: none; color: var(--background-color)" [href]="urlMessage"> {{ message }}</a>
      }
      @if (urlMessage === null || urlMessage === undefined) {
        <span [innerHTML]="message"></span>
      }
    </div>
  </dx-toast>
}
@if (key === 'root_error') {
  <dx-toast id="root_error" key="root_error" [width]="600" [displayTime]="timeMessage" [closeOnClick]="false" [(visible)]="isVisible" [type]="MSG_SEVERITY.ERROR">
    <div style="text-align: center" *dxTemplate="let data of 'content'">
      <div class="d-flex flex-column">
        <strong [innerHTML]="message"></strong>
      </div>
      <div class="d-flex flex-row">
        <div class="mr-auto">
        </div>
        <div>
          <yo-button
            (onClick)="yoErrorHelp.getHelp()"
            label="Détails"
            [theme]="ButtonThemeEnum.SECONDARY_INNER">
          </yo-button>
        </div>
      </div>
    </div>
  </dx-toast>
}

<p-sidebar
  [closeOnEscape]="false"
  appendTo="body"
  [style]="{width:'90%'}"
  [(visible)]="utils.sidenav"
  position="right"
  (onHide)="onHideSideBar()"
  #sidebar
>
  <router-outlet name="secondary"></router-outlet>
  @if (key === 'sidebar') {
    <dx-toast id="toast-sidebar" key="sidebar" [width]="600" [displayTime]="timeMessage" [closeOnClick]="false" [(visible)]="isVisible" [type]="type">
    </dx-toast>
  }
  @if (key === 'sidebar_center') {
    <dx-toast id="toast-sidebar-center" key="sidebar_center" [width]="600" [displayTime]="timeMessage" [closeOnClick]="false" [(visible)]="isVisible" [type]="type">
    </dx-toast>
  }
</p-sidebar>

<router-outlet name="tertiary"></router-outlet>

@if (isLoggedIn$ | async) {
  <div class="d-flex toolbar" [style.height.px]="HEADER_HEIGHT_PX">
    <div class="mr-auto mg-l-40">
      <yo-breadcrumb [selectedItem]="itemNavSvc.selectedMenuItem"></yo-breadcrumb>
    </div>
    <div>

      @if (environnement$ | async) {
        <span
          class="font-12 cursor mg-r-10"
          title="Environnement sélectionné : {{selectedEnvironnementDTO?.libelle}}"

          (click)="initItemsMenuEnvrionnementsAndDisplay($event)"
          #environnement>
          <i class="fa fa-globe mg-r-5"></i>{{ selectedEnvironnementDTO?.libelle }}
        </span>

        <p-menu id="menuEnvironnements" #menuEnvironnements [popup]="true" [model]="itemsMenuEnvironnements"></p-menu>

      }


      <span (click)="openPreferences()" #loggedIn [title]="getResponsiveLabelLogin('long')"
            class="font-12 cursor mg-r-10"
      >
        <i class="fa fa-user-circle mg-r-5"></i>
        {{ getResponsiveLabelLogin(bandeauWidthType) }}
      </span>

      <span class="mg-r-10">
              <i (click)="logout()" class="fa fa-power-off logout-icon"></i>
      </span>

    </div>
  </div>

  <div class="d-flex app-content">
    <yo-left-app-menu></yo-left-app-menu>
    <main #mainContent class="content">
      <router-outlet></router-outlet>
    </main>
  </div>
} @else {
  <router-outlet></router-outlet>
}

<yo-help [dialogMsgSupplier]="utils.detailError" iconClick="hidden" [width]="800" #yoErrorHelp></yo-help>

<yo-preferences-dialog-edit></yo-preferences-dialog-edit>

<p-blockUI [blocked]="isBlockedUI"></p-blockUI>
